module.exports = new __parcel__URL__("soil-texture-background.b23e3b42.jpeg").toString();